(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-category-nav"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initMobileCategoryNav() {
    var navbar = document.querySelector('.mobile-category-nav[data-hide-scroll="true"]');
    if (!navbar) return;

    var debug = navbar.getAttribute('data-debug') === 'true';
    var log = debug ? function() {
      if (typeof console !== 'undefined' && console.log) {
        console.log.apply(console, ['[MCN]'].concat([].slice.call(arguments)));
      }
    } : function() {};

    var lastTouchY = 0;
    var raf = null;
    var lastDir = '';

    function applyDir(direction) {
      if (raf) return;
      raf = requestAnimationFrame(function() {
        raf = null;
        if (direction === 'down') {
          navbar.classList.add('hide');
          lastDir = 'down';
          log('hide');
        } else {
          navbar.classList.remove('hide');
          lastDir = 'up';
          log('show');
        }
        if (debug) {
          var b = document.getElementById('mcn-debug-banner');
          if (b) b.textContent = 'MCN OK | ' + lastDir;
        }
      });
    }

    var wheelOpt = { passive: true };
    function onWheel(e) {
      var dy = e.deltaY;
      if (dy > 10) applyDir('down');
      else if (dy < -10) applyDir('up');
    }

    function onTouchStart(e) {
      if (e.touches.length) lastTouchY = e.touches[0].clientY;
    }

    function onTouchMove(e) {
      if (!e.touches.length) return;
      var y = e.touches[0].clientY;
      var dy = y - lastTouchY;
      lastTouchY = y;
      if (dy > 12) applyDir('down');
      else if (dy < -12) applyDir('up');
    }

    document.addEventListener('wheel', onWheel, wheelOpt);
    document.addEventListener('touchstart', onTouchStart, wheelOpt);
    document.addEventListener('touchmove', onTouchMove, wheelOpt);

    log('Using wheel + touch (no scroll container)');
    navbar.classList.remove('hide');

    if (debug) {
      var banner = document.createElement('div');
      banner.id = 'mcn-debug-banner';
      banner.style.cssText = 'position:fixed;bottom:12px;right:12px;z-index:999999;background:#c00;color:#fff;font:14px monospace;padding:8px 12px;border-radius:6px;box-shadow:0 2px 8px rgba(0,0,0,.3);';
      banner.textContent = 'MCN OK | wheel+touch';
      document.body.appendChild(banner);
    }
  }

  function run() {
    initMobileCategoryNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('turbo:load', run);
  setTimeout(run, 100);
  setTimeout(run, 500);
})();

  } catch(e) { console.error(e); }
})();
})();
